// Small layout primitives shared between DraftItemEditRow and the
// dimensions/places editor split out for the 600 LOC hard cap.

import type { ReactNode } from 'react';

export function Field({
  label,
  required,
  children,
}: {
  label: string;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <div>
      <div
        style={{
          fontSize: 11,
          color: 'var(--fg-3)',
          marginBottom: 5,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        {label}
        {required && <span style={{ color: 'var(--status-error-fg)' }}>*</span>}
      </div>
      {children}
    </div>
  );
}

export function Grid({ minWidth, children }: { minWidth: number; children: ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`,
        gap: 12,
      }}
    >
      {children}
    </div>
  );
}

export function parseQuantityInput(value: string): number {
  const parsed = Number(value.trim());
  if (!Number.isFinite(parsed)) return 0;
  return Math.trunc(parsed);
}

export function parseIntInput(value: string): number {
  const parsed = Number(value.trim());
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return Math.trunc(parsed);
}

export function formatIntInput(value: number): string {
  return value === 0 ? '' : String(Math.trunc(value));
}

export function formatM3Display(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0';
  const rounded = Math.round(value * 10000) / 10000;
  return String(rounded);
}
